export default __webpack_public_path__ + "static/media/coursera.61f07c1e.jpeg";